//default from angular libraries
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, finalize } from "rxjs/operators";

//import constants
import { AppSettings } from '../constants/app-settings';

//import services
import { GeneralService } from '../services/general.service';
import { AuthService } from '../services/auth.service';

declare var MINOVATE: any;

@Injectable()

export class HttpConfigInterceptor implements HttpInterceptor {

    private MINOVATES = MINOVATE();

    constructor(
        private generalService: GeneralService,
        private authService: AuthService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (!request.headers.has('Content-Type') && !request.headers.has('isFileUpload')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        if (!request.headers.has(AppSettings.API_KEY_FIELD)) {
            request = request.clone({ headers: request.headers.set(AppSettings.API_KEY_FIELD, AppSettings.API_KEY) });
        }

        var user_key = this.authService.user_key();
        if (user_key) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + user_key) });
        }

        if (!request.headers.has('loader'))
            this.MINOVATES.restLoader.enable();
        else
            request = request.clone({ headers: request.headers.delete('loader', 'false') });

        return next.handle(request).pipe(
            catchError((error) => this.handleError(error)),
            finalize(() => this.MINOVATES.restLoader.disable())
        );


    }

    private handleError(error: HttpErrorResponse) {
        this.MINOVATES.restLoader.disable();

        var login = this.authService.isLoggedIn();

        if (!navigator.onLine)
            this.generalService.notify_msg('error', 'Internet connection problem');
        else if (error.status == 401 && login) {
            this.generalService.notify_msg('error', 'Kindly login before access');
            this.authService.logout();
        }
        else if (error.status != 401)
            this.generalService.notify_msg('error', 'Some issues in server. Please try again.');

        return throwError(error);
    }
}